import classNames from 'classnames';
import { ReactComponent as Close } from '../../common/icons/close.svg';
import isMobile from '../../common/utils/isMobile';

interface PopupHeaderProps {
  title?: string;
  subtitle?: string;
  onClose: () => void;
  onKeyPress?: (e: unknown) => void;
}

export function PopupHeader({
  title,
  subtitle,
  onClose,
  onKeyPress,
}: PopupHeaderProps) {
  return (
    <div className="GiftBox-Header flex justify-between mb-6">
      <div className="Wrappable-Container-In-Flex">
        {title ? (
          <h1 className="GiftBox-Header-Title mb-1 text-gray-900 text-heading-lg mr-8 Giftbox-TextOverflowEllipsis">
            {title}
          </h1>
        ) : null}

        {subtitle ? (
          <h2 className="GiftBox-Header-Subtitle text-gray-600 text-heading-sm Giftbox-TextOverflowEllipsis">
            {subtitle}
          </h2>
        ) : null}
      </div>
      <div
        onClick={onClose}
        onKeyPress={onKeyPress}
        className={classNames(
          'hover:cursor-pointer p-2.5 flex items-center justify-center absolute right-3 [&>svg]:fill-gray-600 [&>svg]:hover:fill-gray-800 [&>svg]:active:fill-gray-900',
          {
            'top-1': isMobile(),
            'top-4': !isMobile(),
          },
        )}
      >
        <Close
          className="GiftBox-Close-Button"
          data-cy="close-popup"
          tabIndex={0}
        />
      </div>
    </div>
  );
}
